module.exports = __webpack_public_path__ + "img/WhatsApp Image 2019-11-21 at 4.32.05 PM.55c2b9d4.jpeg";